import { render, staticRenderFns } from "./interests-page.vue?vue&type=template&id=d4583e0e&scoped=true&"
import script from "./interests-page.vue?vue&type=script&lang=js&"
export * from "./interests-page.vue?vue&type=script&lang=js&"
import style0 from "./interests-page.vue?vue&type=style&index=0&id=d4583e0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4583e0e",
  null
  
)

export default component.exports